import { productCardCTA } from '../../../app/Libraries/ProductCardAvailability';

// The fitting room and its assets run on the current Raffi storefront.
export const STUDIO_ORIGIN = typeof window !== 'undefined' ? window.location.origin : 'https://www.raffi-jewellers.ca';
export const STUDIO_PATH = '/watch-studio/';
export const PROTOCOL = 'wrist-studio';
export const VERSION = 1;

export function isRolexPath(path) {
  let value = String(path || '');
  try { value = decodeURIComponent(value); } catch (_) { /* Keep invalid encoded paths conservative. */ }
  return /(?:^|\/)rolex(?:[-/]|$|[?#])/i.test(value);
}

export function isWatchType(value) {
  return /^(timepieces|watches|watch)$/i.test(String(value || '').trim());
}

export function escapeMarkup(value) {
  return String(value == null ? '' : value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
}

export function productURL(handle, variant, locale = 'en') {
  if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/i.test(String(handle || '')) || /^rolex(?:-|$)/i.test(handle)) return '';
  const url = new URL(`${locale === 'fr' ? '/fr' : ''}/products/${handle}`, 'https://native.invalid');
  const id = String(variant || '').replace(/^gid:\/\/shopify\/ProductVariant\//, '');
  if (/^\d+$/.test(id)) { url.searchParams.set('v', id); url.searchParams.set('oid', id); }
  return url.pathname + url.search;
}

export function normalizeProduct(input, pageURL) {
  if (!input || typeof input !== 'object' || /rolex/i.test(String(input.brand || '')) || typeof input.image !== 'string' || !input.image.trim() || typeof input.url !== 'string' || !input.url.trim()) return null;
  try {
    const page = new URL(pageURL);
    const url = new URL(input.url, page);
    const image = new URL(input.image, page);
    if (isRolexPath(page.pathname) || url.origin !== page.origin || !/^\/(?:fr\/)?products\/[a-z0-9-]+\/?$/i.test(url.pathname) || /^\/(?:fr\/)?products\/rolex(?:-|\/|$)/i.test(url.pathname)) return null;
    if (url.username || url.password || image.username || image.password || !['https:', 'http:'].includes(page.protocol) || image.protocol !== 'https:') return null;
    const selection = safeSelection(url.searchParams.get('selection'), input.brand, pageURL);
    // Return links retain a validated catalogue selection and variant, never signed inquiry tokens.
    for (const key of [...url.searchParams.keys()]) if (!['v', 'oid'].includes(key)) url.searchParams.delete(key);
    if (selection) url.searchParams.set('selection', selection);
    url.hash = '';
    const id = String(input.id || '').slice(0, 400), title = String(input.title || '').slice(0, 240);
    if (!id || !title) return null;
    return {id, title, brand:String(input.brand || '').slice(0,120), sku:String(input.sku || '').slice(0,120), image:image.href, images:[image.href], url:url.href};
  } catch (_) { return null; }
}

export function safeSelection(value, brand, pageURL) {
  if (typeof value !== 'string' || value.length > 4096 || !value.startsWith('/') || value.startsWith('//')) return '';
  try {
    const page = new URL(pageURL), url = new URL(value, page);
    const match = /^\/(fr\/)?collections\/timepieces(?:\/([a-z0-9-]+))?(?:\/|$)/i.exec(url.pathname);
    if (!match || url.origin !== page.origin || isRolexPath(url.pathname) || !!match[1] !== /^\/fr(?:\/|$)/.test(page.pathname)) return '';
    const slug = String(brand || '').toLowerCase().trim().replace(/\s+/g,'-').replace(/^gucci-timepieces$/, 'gucci');
    if (match[2] && match[2] !== slug) return '';
    return url.pathname + url.search + url.hash;
  } catch (_) { return ''; }
}

export function isStudioMessage(event, frameWindow, channel) {
  const d = event && event.data;
  return !!(event && event.origin === STUDIO_ORIGIN && event.source === frameWindow && d && d.protocol === PROTOCOL && d.version === VERSION && d.channel === channel);
}

export function studioURL(product, locale = 'en') {
  const url = new URL(STUDIO_PATH, STUDIO_ORIGIN);
  url.searchParams.set('lang', locale === 'fr' ? 'fr' : 'en');
  url.hash = new URLSearchParams({watch:JSON.stringify(product)}).toString();
  return url.href;
}

export function watchCardActions(product, url, labels, pagePath = '') {
  const action = productCardCTA(product, url, pagePath);
  const e = escapeMarkup;
  const attrs = {id:product.id, title:product.title, brand:product.brand, sku:product.sku, image:product.image, url};
  const data = Object.entries(attrs).map(([key,value]) => `data-watch-${key}="${e(value)}"`).join(' ');
  return `<div class="rf-watch-card-actions"><a href="${e(action.href)}" class="rf-watch-shop">${e(action.inquiry ? labels.inquireAvailability : labels.shopNow)}</a>${product.image ? `<button type="button" class="rf-watch-tryon" data-watch-tryon ${data}>${e(labels.tryOn)}</button>` : ''}</div>`;
}
